export default __webpack_public_path__ + "static/news_aldiana_teaser-a05f198c855623a61afa6886db9b254c.png";